import apiCall from 'shared/utils/apiCall';
import apolloClient from 'store/apolloClient';
import errorAction from 'shared/utils/errorAction';
import createAsyncAction from 'shared/utils/createAsyncAction';
import { addToast } from 'modules/messageSystem/actions/addToast';

import { hideAppointmentInfo } from 'modules/queues/common/actions/appointmentInfo';
import { ARCHIVED, UNENFORCED } from 'modules/queues/constants/queueEnforcementTypes';
import { removeAppointmentFromList } from 'modules/queues/common/actions/appointmentsListActions';
import { isCurrentAppointmentGrouped } from 'modules/appointmentInfo/selectors/currentAppointment';
import { CLOSED_APPOINTMENT_STATUSES, CANCELED } from 'modules/common/constants/appointmentStatuses';
import { getAppointmentsByQueueType } from 'modules/queues/common/selectors/appointmentsByQueueType';
import { updateAppointmentGroupCurrentAppointment } from 'modules/appointmentInfo/actions/updateAppointmentGroupCurrentAppointment';

import createAction from './index';
import * as services from '../services/updateAppointment';
import { changePatientInfoTab } from './changePatientInfoTab';

export const UPDATE_APPOINTMENT = createAsyncAction(createAction('UPDATE_APPOINTMENT'));

export const updateAppointment = ({ appointmentId, status }) => async (dispatch, getState) => {
  dispatch({ type: UPDATE_APPOINTMENT.pending });

  const apiCallParams = {
    mutation: services.UPDATE_APPOINTMENT,
    variables: { appointmentId, status },
    fetchPolicy: 'no-cache',
  };

  return apiCall(apolloClient.mutate, apiCallParams)
    .then(() => {
      const state = getState();
      const appointments = getAppointmentsByQueueType(state).byId;
      const removedIndex = appointments.findIndex(_appointmentId => _appointmentId === appointmentId);
      const listQueueType = state.queues.common.appointmentInfo.isArchiveOpened ? ARCHIVED : UNENFORCED;
      if (removedIndex >= 0) dispatch(removeAppointmentFromList(appointmentId, listQueueType));

      if ([CANCELED].includes(status)) {
        dispatch(addToast('success', 'close-appointment-toast', {
          id: 'Patient.Appointment.CancelAppointment.SuccessSnackbar',
          defaultMessage: '** Appointment cancelled successfully',
        }));
      }
      if (!isCurrentAppointmentGrouped(state)) {
        dispatch(hideAppointmentInfo());
      } else {
        const { currentAppointment } = state.appointmentInfo;
        const tempApptGroup = currentAppointment.group.appointments.filter(
          tempAppt => !CLOSED_APPOINTMENT_STATUSES.includes(tempAppt.status),
        );

        if (tempApptGroup.length < 2) {
          dispatch(hideAppointmentInfo());
        } else {
          const currIndex = tempApptGroup.findIndex(({ appointmentId }) => currentAppointment.appointmentId === appointmentId);
          const nextAppointmentId = tempApptGroup[currIndex + 1]
            ? tempApptGroup[currIndex + 1].appointmentId
            : tempApptGroup[0].appointmentId;
          dispatch(changePatientInfoTab('1'));
          dispatch(updateAppointmentGroupCurrentAppointment(nextAppointmentId));
        }
      }
      return dispatch({ type: UPDATE_APPOINTMENT.success });
    })
    .catch((err) => {
      dispatch(errorAction(UPDATE_APPOINTMENT.failure, err));
    });
};
